// Any member of the zone can identify it, so take the first source that
// actually carries a value rather than the first source that exists. A switch
// added during this edit is a real entry built from makeBlankSwitch, whose
// zoneId/latitude/longitude are all null — reading it outright sent the update
// to /zones/null. Same reasoning as the device_mac lookup in
// updateSysIdentificationData.
const firstDefined = (sources, ...keys) => {
  for (const source of sources) {
    for (const key of keys) {
      if (source?.[key] !== null && source?.[key] !== undefined) {
        return source[key];
      }
    }
  }
  return null;
};

export const getZoneIdentity = (switches, deletedPanels) => {
  // Remaining switches first: a deleted panel is the fallback, not the truth.
  const sources = [
    ...(switches ?? []).flat().filter(Boolean),
    ...(deletedPanels ?? []).filter(Boolean),
  ];

  return {
    longitude: firstDefined(sources, 'longitude'),
    latitude: firstDefined(sources, 'latitude'),
    zone_id: firstDefined(sources, 'zoneId', 'zone_id'),
  };
};

